<script lang="ts">
  import type { AuthContext } from "$src/infrastructure/accounts/AuthContext";
  import { ContextTokens } from "$src/presentation/contexts/ContextTokens";
  import { createEventDispatcher, getContext, onMount } from "svelte";
  import { fade } from "svelte/transition";
  import DocumentList from "./viewer/document-list.svelte";
  import DocumentViewer from "./viewer/document-viewer.svelte";
  import { push, params } from 'svelte-spa-router';
  import { StringUtils } from "$lib/stringUtils";
  import MainTemplate from "$src/presentation/main/main-template.svelte";
  import ProjectTemplate from "../components/project-template.svelte";

  let { activeGroupStore }  : AuthContext = getContext(ContextTokens.Auth);
  let projectId: number;
  let selectedDocumentId: string |undefined;

  onMount(() => extractParams($params));
	
  $: extractParams($params)
	function extractParams(parameters?: Record<string,string>) {
    selectedDocumentId = parameters?.documentId;
    projectId =  StringUtils.getNumberOrDefault(parameters?.projectId, 0);
	}

  const goBack = () => {
    selectedDocumentId = undefined;
    push(`/gs/${$activeGroupStore?.groupStoreId}/projects/${projectId}/documents`);
  };

  const selectDocument = (event: CustomEvent<string>) => {
    selectedDocumentId = event.detail;
    push(`/gs/${$activeGroupStore?.groupStoreId}/projects/${projectId}/documents/${selectedDocumentId}`);
  };

  const handleNextDocument = () => {
    const event = new CustomEvent('nextDocument');
    document.dispatchEvent(event);
  };

  const handlePreviousDocument = () => {
    const event = new CustomEvent('previousDocument');
    document.dispatchEvent(event);
  };

</script>

<ProjectTemplate isEmbedded={true}>
  {#if $activeGroupStore?.groupStoreId }
    <div in:fade class="flex flex-row h-full overflow-hidden" >
      <div class="{selectedDocumentId ? 'hidden md:flex' : ''} max-w-md flex w-full mx-auto p-1 ">
        <DocumentList 
          groupStoreId={$activeGroupStore.groupStoreId} 
          projectId={projectId}
          selectedDocumentId={selectedDocumentId}
          on:documentClick={selectDocument} 
          /> 
      </div>
      <div class="{selectedDocumentId ? '' : 'hidden md:block'} md:block container mx-auto max-w-full p-1 overflow-hidden ">
        <DocumentViewer 
          groupStoreId={$activeGroupStore.groupStoreId} 
          projectId={projectId}
          selectedDocumentId={selectedDocumentId}
          on:previousDocument={handlePreviousDocument}
          on:nextDocument={handleNextDocument}
          onBack={goBack}
          />
      </div>
    </div>
  {/if}
</ProjectTemplate>